import { cn } from "cn";
import { isEmpty } from "lodash-es";
import {
  BwBuildingOffice1Line,
  BwBuildingOffice2Line,
  BwBuildingOfficeLine,
  BwHomeLine,
} from "@/components/ui/icons";
import { PlaceType } from "@/types/openapi-enum";

export const getTypeSpecs = (type: PlaceType) => {
  let iconColor = "";
  let Icon: any;

  switch (type) {
    case PlaceType.Building:
      iconColor = "text-text-dark-low";
      Icon = BwBuildingOffice1Line;
      break;
    case PlaceType.House:
      iconColor = "text-text-dark-low";
      Icon = BwHomeLine;
      break;
    case PlaceType.Office:
      iconColor = "text-text-dark-low";
      Icon = BwBuildingOffice2Line;
      break;
    default:
      iconColor = "text-text-dark-low";
      Icon = BwBuildingOfficeLine;
      break;
  }

  return {
    iconColor,
    Icon,
  };
};

export function PlaceTypeIcon({
  type,
  size = 16,
  className,
}: {
  type: PlaceType;
  size?: number;
  className?: string;
}) {
  if (isEmpty(type)) {
    return null;
  }

  const { iconColor, Icon } = getTypeSpecs(type);
  return <Icon size={size} className={cn(iconColor, "shrink-0", className)} />;
}
